(() => {
  // Support the local page renderer as well as Shopify's native policy markup.
  if (window.location.pathname.includes('/policies/') && !document.querySelector('.shopify-policy__body')) {
    const page = document.querySelector('#MainContent .cabane-editorial-page');
    const content = page?.querySelector('.rte');
    const heading = page?.querySelector('h1');
    if (page && content && heading) {
      const container = document.createElement('div');
      container.className = 'shopify-policy__container';
      const title = document.createElement('div');
      title.className = 'shopify-policy__title';
      const body = document.createElement('div');
      body.className = 'shopify-policy__body';
      heading.classList.remove('scroll-trigger','animate--fade-in');
      content.classList.remove('scroll-trigger','animate--slide-in');
      title.append(heading); body.append(content); container.append(title,body);
      page.replaceChildren(container);
    }
  }
  const root = document.querySelector('.shopify-policy__body .rte');
  if (!root || root.dataset.cabanePolicyEnhanced === 'true') return;

  const isLegalNotice = window.location.pathname.includes('/policies/legal-notice');
  const isShippingPolicy = window.location.pathname.includes('/policies/shipping-policy');
  const isTermsOfSale = window.location.pathname.includes('/policies/terms-of-sale');
  const isPrivacyPolicy = window.location.pathname.includes('/policies/privacy-policy');
  const isRefundPolicy = window.location.pathname.includes('/policies/refund-policy');
  const isContactInformation = window.location.pathname.includes('/policies/contact-information');

  root.dataset.cabanePolicyEnhanced = 'true';
  root.dataset.cabanePolicyKind = isLegalNotice
    ? 'legal-notice'
    : isTermsOfSale
      ? 'terms-of-sale'
      : isPrivacyPolicy
        ? 'privacy-policy'
        : isRefundPolicy
          ? 'refund-policy'
          : isContactInformation
            ? 'contact-information'
            : 'shipping-policy';

  if (isLegalNotice) {
    document
      .querySelector('.shopify-policy__title')
      ?.classList.add('cabane-policy__title--legal-notice');
  }

  if (isTermsOfSale) {
    document
      .querySelector('.shopify-policy__title')
      ?.classList.add('cabane-policy__title--terms-of-sale');
  }

  if (isPrivacyPolicy) {
    document
      .querySelector('.shopify-policy__title')
      ?.classList.add('cabane-policy__title--privacy-policy');
  }

  if (isRefundPolicy) {
    document
      .querySelector('.shopify-policy__title')
      ?.classList.add('cabane-policy__title--refund-policy');
  }

  if (isContactInformation) {
    document
      .querySelector('.shopify-policy__title')
      ?.classList.add('cabane-policy__title--contact-information');
  }

  if (isShippingPolicy || isLegalNotice) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const textNodes = [];

    while (walker.nextNode()) textNodes.push(walker.currentNode);

    textNodes.forEach((node) => {
      node.nodeValue = node.nodeValue.replace(/\u00a0/g, ' ');
    });
  }

  if (isShippingPolicy) {
    root.querySelectorAll('p br').forEach((lineBreak) => {
      lineBreak.replaceWith(document.createTextNode(' '));
    });
  }

  const normalizeHeading = (value) =>
    value
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/’/g, "'")
      .toUpperCase();

  const markPolicyEdgeBreaks = (element) => {
    const markBreaks = (nodes) => {
      for (const node of nodes) {
        if (
          node.nodeType === Node.TEXT_NODE &&
          !node.textContent.replace(/\u00a0/g, ' ').trim()
        ) {
          continue;
        }

        if (node.nodeName === 'BR') {
          node.classList.add('cabane-policy__redundant-break');
          continue;
        }

        break;
      }
    };

    const childNodes = [...element.childNodes];
    markBreaks(childNodes);
    markBreaks(childNodes.reverse());
  };

  const firstParagraph = root.querySelector('p');
  markPolicyEdgeBreaks(root);
  root.querySelectorAll('td').forEach(markPolicyEdgeBreaks);

  root.querySelectorAll('p').forEach((paragraph) => {
    markPolicyEdgeBreaks(paragraph);

    const text = paragraph.textContent.replace(/\s+/g, ' ').trim();

    if (!text) {
      paragraph.hidden = true;
      return;
    }

    if (isShippingPolicy && /^8\.\d+\b/.test(text)) {
      paragraph.classList.add('cabane-shipping-policy__section-title');
      return;
    }

    if (isShippingPolicy && /^Articles (en stock|sur commande)/i.test(text)) {
      paragraph.classList.add('cabane-shipping-policy__subheading');
      return;
    }

    if (isRefundPolicy && /^\d+\.\d+\b/.test(text)) {
      paragraph.classList.add('cabane-shipping-policy__section-title');
      return;
    }

    if (isTermsOfSale) {
      const normalizedText = normalizeHeading(text);

      if (
        paragraph === firstParagraph &&
        normalizedText === 'CONDITIONS GENERALES DE VENTE'
      ) {
        paragraph.hidden = true;
        return;
      }

      if (/^\d+\.\d+\b/.test(text)) {
        paragraph.classList.add('cabane-shipping-policy__subheading');
        return;
      }

      const strong = paragraph.firstElementChild;
      if (
        paragraph.children.length === 1 &&
        strong?.tagName === 'STRONG' &&
        text.length <= 100
      ) {
        paragraph.classList.add('cabane-policy__detail-heading');
        return;
      }
    }

    if (isLegalNotice) {
      const normalizedText = normalizeHeading(text);

      const isSectionTitle = [
        /^IDENTITE DE L'EXPLOITANT\b/,
        /^CONTACT\b/,
        /^HEBERGEMENT\b/,
        /^POLITIQUE DE PROTECTION DES DONNEES A CARACTERE PERSONNEL\b/,
      ].some((pattern) => pattern.test(normalizedText));

      if (isSectionTitle) {
        paragraph.classList.add('cabane-shipping-policy__section-title');
        return;
      }

      const isSubheading = [
        /^DESTINATAIRES DES DONNEES\b/,
        /^UTILISATION COMMERCIALES DES DONNEES\b/,
        /^PROTECTION DES DONNEES PERSONNELLES\b/,
        /^FINALITES DU TRAITEMENT DES DONNEES\b/,
        /^ACCES ET RECTIFICATION DE VOS DONNEES PERSONNELLES\b/,
      ].some((pattern) => pattern.test(normalizedText));

      if (isSubheading) {
        paragraph.classList.add('cabane-shipping-policy__subheading');
      }
    }
  });

  if (isPrivacyPolicy) {
    [...root.querySelectorAll('h2')].forEach((heading, index) => {
      heading.classList.add('cabane-shipping-policy__section-title');

      if (index === 0) {
        heading.classList.add('cabane-policy__section-title--first');
      }
    });
  }

  if (isRefundPolicy) {
    root
      .querySelector('.cabane-shipping-policy__section-title')
      ?.classList.add('cabane-policy__section-title--first');
  }

  const introduction = root.querySelector('ol');
  if (isShippingPolicy && introduction?.textContent.trim()) {
    introduction.classList.add('cabane-shipping-policy__intro');
  }

  if (isTermsOfSale) {
    const sectionLists = [...root.querySelectorAll('ol')].filter(
      (list) =>
        list.querySelectorAll(':scope > li').length === 1 &&
        list.textContent.replace(/\s+/g, ' ').trim().length <= 100,
    );

    sectionLists.forEach((list, index) => {
      list.classList.add('cabane-policy__terms-section');
      list.start = index + 1;

      if (index === 0) {
        list.classList.add('cabane-policy__terms-section--first');
      }
    });
  }
})();
